import React, { useState, useEffect } from "react";
import { showUsersByRoleApi } from "../../../services/Admin/user";
import { Dialog, Typography, DialogContent, DialogActions, Button, TextField, Select, InputLabel, FormControl, MenuItem } from "@mui/material";
import MsgError from "../../MsgError";
import MsgSuccess from "../../MsgSuccess";
import { listApi } from "../../../services/Admin/request";
import Autocomplete from "@mui/material/Autocomplete";

export default function AddMediaModal({
    open, onClose, onAdd, loadingAdd,
    msgError, msgSuccess,
    newFile, setNewFile,
    newText, setNewText,
    newType, setNewType,
    user, setUser,
    fileTypes
}) {
    const [optionsUser, setOptionsUser] = useState([]);
    const [userSearch, setUserSearch] = useState("");

    useEffect(() => {
        setOptionsUser([])
        console.clear()
        listApi("user")
            .then(res => {
                setOptionsUser(res.data.data || [])
            })
            .catch(err => console.error(err));
    }, []);
    
    // Filtrar usuarios según el texto de búsqueda
    const filteredUsers = optionsUser.filter(u => {
        const fullName = `${u.name?.toLowerCase() || ''} ${u.surnames?.toLowerCase() || ''}`.trim();
        const email = u.email?.toLowerCase() || '';
        const search = userSearch.toLowerCase();
        return fullName.includes(search) || email.includes(search);
    });

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                }
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: "rgba(0,0,0,0.4)",
                        backdropFilter: "blur(5px)",
                    },
                },
            }}
        >
            <DialogContent style={{ padding: 30, position: "relative", borderRadius: 12 }}>
                <Typography id="modal-modal-title" variant="h6" component="h2" align="center">
                    Añadir archivo
                </Typography>
                <br />
                <div style={{ marginBottom: 16 }}>
                    <input
                        id="add-media-file-input"
                        type="file"
                        required
                        style={{ display: "none" }}
                        onChange={e => setNewFile(e.target.files[0] || null)}
                    />
                    <label htmlFor="add-media-file-input">
                        <Button
                            variant="contained"
                            component="span"
                            color="primary"
                            fullWidth
                            sx={{ textTransform: "none", borderRadius: 2 }}
                        >
                            {newFile ? `Archivo seleccionado: ${newFile.name}` : "Seleccionar archivo"}
                        </Button>
                    </label>
                </div>

                <Autocomplete
                    // Lista completa de usuarios cargados
                    options={optionsUser}

                    // Mostrar nombre y apellidos como etiqueta de resultado
                    getOptionLabel={(option) => {
                        const name = option.name?.trim() || '';
                        const surnames = option.surnames?.trim() || '';
                        const email = option.email || '';
                        let label = `${name} ${surnames}`.trim();
                        if (label && email) label += ` (${email})`;
                        else if (!label && email) label = email;
                        return label;
                    }}

                    // Valor seleccionado actualmente
                    value={
                        optionsUser.find(u => u.id === user) || null
                    }

                    // Al seleccionar un usuario, actualizamos el estado con su ID
                    onChange={(e, value) => setUser(value?.id || "")}

                    // Filtrado personalizado por nombre + apellidos + email
                    filterOptions={(options, state) => {
                        const search = state.inputValue.toLowerCase();
                        return options.filter(u => {
                            const full = `${u.name || ''} ${u.surnames || ''}`.toLowerCase();
                            const email = u.email?.toLowerCase() || "";
                            return full.includes(search) || email.includes(search);
                        });
                    }}

                    // UI del campo
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Usuari"
                            required
                            margin="dense"
                            InputLabelProps={{ shrink: true }}
                        />
                    )}

                    // Placeholder cuando no hay datos
                    noOptionsText="No s'han trobat resultats"

                    fullWidth
                    sx={{ marginBottom: 2 }}
                />

                <FormControl fullWidth margin="dense" required>
                    <InputLabel id="type-label" shrink>Tipo</InputLabel>
                    <Select
                        labelId="type-label"
                        value={newType}
                        label="Tipo"
                        onChange={e => setNewType(e.target.value)}
                    >
                        {fileTypes.map(opt => (
                            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    label="Descripción"
                    value={newText}
                    onChange={e => setNewText(e.target.value)}
                    fullWidth
                    required
                    margin="dense"
                    multiline
                    minRows={3}
                    InputLabelProps={{ shrink: true }}
                />

                {msgError && <MsgError msg={msgError} />}
                {msgSuccess && <MsgSuccess msg={msgSuccess} />}
                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16, marginTop: 20 }}>
                    <div style={{ width: "50%" }}>
                        <Button
                            onClick={onClose}
                            variant="contained"
                            className="MuiButton-containedCancel"
                            fullWidth
                        >
                            Cancelar
                        </Button>
                    </div>
                    <div style={{ width: "50%" }}>
                        <Button
                            onClick={onAdd}
                            color="primary"
                            variant="contained"
                            fullWidth
                            disabled={loadingAdd}
                        >
                            Guardar
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
